import React from "react";
import img from "../../../Assets/ISO Certification/img4.png";

const ISOBenifit9001 = () => {
  return (
    <>
      <div className="w-full grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 p-10">
        {/* right side content  */}

        <div className="col-span-1 gap-4 w-full">
          <div className="text-center w-full lg:w-auto">
            {" "}
            <img src={img} alt="" className="rounded-lg w-full lg:w-auto" />
          </div>
        </div>

        {/* left side images  */}
        <div className="w-full text-[#032303] font-medium sm:text-3xl md:font-medium text-md lg:text-4xl lg:col-span-1 xl:col-span-2 py-4 lg:py-0 ">
          <h1 className="">
            <span className="border-b-4 border-[#249742]"> Get Be</span>
            nefits of ISO Certified
          </h1>

          <div className="py-2 ">
            <ol className="list-disc font-normal text-sm md:text-xl lg:text-sm xl:text-xl py-4 text-[#4D4D4D]">
              <li>
                The production, development and supply of products and services
                become more safe and efficient.
              </li>
              <li>
                ISO certification sets new goals to be achieved and continuous
                improvement becomes possible to be achieved.
              </li>
              <li>
                It is also possible for the management of the organization
                certified to monitor the progress step by step to achieve the
                goals of standard products. Furthermore, productivity is
                increased as a result of improved process due to improved
                qualification of employees.
              </li>
              <li>International trade becomes fairer.</li>
              <li>
                Provision of safe products and services to consumers becomes
                possible.
              </li>
              <li>
                The ISO certified company can compete at international level.
              </li>
              <li>
                The new technologies which achieve the ISO certificate have the
                possibility to be implemented in the production process.
              </li>
              <li>
                The developing countries gain advanced technical knowledge when
                they have to implement the standers for production with their
                scares resources.
              </li>
              <li>
                Quality of life in general improves as everyone is ensured of
                the provision of safe products and services.
              </li>
              <li>
                Global environment is assured to be safe with International
                standers for goods and services to be produced which are
                environment-friendly.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </>
  );
};

export default ISOBenifit9001;
